/**
 * @flow
 */

import styled from 'react-emotion'

import Colors from '../../../themes/Colors'
import { Typo14WhiteTwoDD } from '../../../themes/Fonts/Din2014'
import { mobile } from '../../../utils/mixins'

export const DownloadButtonContainer = styled('div')`
  display: flex;
  align-items: center;
  border: 1px solid ${Colors.pumpkinOrange};
  outline: none;
  padding: 7px 20px;
  background: ${Colors.pumpkinOrange};
  cursor: pointer;
`
export const ButtonText = styled(Typo14WhiteTwoDD)`
  letter-spacing: 0.5px;
  ${mobile} {
    font-size: 12px;
  }
  margin-right: 0px;
  color: white;
  pointer-events: none;
`
export const ButtonContainer = styled('div')`
  display: flex;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/EnquireNowButton/styledComponents.js